
<!--<div *ngIf="fileTypes!=null && fileTypes!=undefined">
  <p class="commonpara"  style="color: #FF4438">
    Allowed file types: {{fileTypes}}
  </p>
</div>-->

<div class="profileupload" *ngIf="uploadType =='single' && extensionType!='document'">
    <i class="icofont icofont-upload-alt icon" (click)="file.click()" style="cursor:pointer"></i>
    <table class="table basictable uploaded-image-name" style="width:auto;display:none">
        <thead>
        </thead>
        <tbody>
            <tr *ngFor="let img of selectFiles;let i = index" [attr.data-index]="i">
                <td class="breakall">
                    {{img.name}}
                    <a href="javascript:void(0);" class="remove" tooltip="Remove" (click)="removeImage(i,$event)" placement="top"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<div class="dragndropdesign">
  <div draggable="true" ngClass="{{dragAreaClass}}" *ngIf="uploadType !='single'">
    <div class="row">
      <div class="col-md-12 text-center" (click)="fileBrowse.click()">
        <i class="icofont icofont-upload-alt icon" aria-hidden="true"></i>
        <p>Click to browse Or Drag and drop it here</p>

      </div>
    </div>
  </div>
  <input type="file"
         #fileBrowse
         [multiple]="(maxFiles > 1)" (click)="fileBrowse.value = null"
         (change)="onFileChange($event)"
         style="display:none" />
  <br />
  <p class="info-tex text-center" style="font-size:10px" *ngIf="restrictionText != null && restrictionText != undefined && restrictionText.length > 0">{{restrictionText}}</p>
  <div class="text-center">

    <table class="table table-bordered file-table" *ngIf="selectFiles.length > 0 && uploadType !='single' && showList">
      <thead>
        <tr>
          <th>Selected Files</th>

          <th>Remove</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let img of selectFiles;let i = index" [attr.data-index]="i">
          <td>{{img.name}}</td>
          <td><a href="#" (click)="removeImage(i,$event)">Remove</a></td>

        </tr>
      </tbody>
    </table>

  </div>
  <div class="row error" *ngIf="errors.length > 0 && uploadType !='single'">
    <ul>
      <li *ngFor="let err of errors">{{err}}</li>
    </ul>
  </div>
 
</div>

<div class="dragndropdesign">
  <div draggable="true" ngClass="{{dragAreaClass}}" *ngIf="uploadType =='single' && extensionType=='document'">
    <div class="row">
      <div class="col-md-12 text-center" (click)="file.click()">
        <i class="icofont icofont-upload-alt icon" aria-hidden="true"></i>
        <p>Click to browse Or Drag and drop it here</p>

      </div>
    </div>
  </div>
  <input type="file"
         #file
         (click)="file.value = null"
         (change)="onFileChange($event)"
         style="display:none" />

  <div class="text-center">

    <table class="table table-bordered" *ngIf="selectFiles.length > 0 && uploadType =='single' && extensionType=='document'">

      <tbody>
        <tr *ngFor="let img of selectFiles;let i = index" [attr.data-index]="i">
          <td class="breakall" valign="middle">
            <span class="pull-left">{{img.name}}</span>
            <a href="javascript:void(0);" class="remove pull-right" tooltip="Remove" (click)="removeImage(i,$event)" placement="top"><i class="icofont icofont-close" aria-hidden="true"></i></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row error" *ngIf="errors.length > 0 && uploadType =='single' && extensionType=='document'">
    <ul>
      <li *ngFor="let err of errors">{{err}}</li>
    </ul>
  </div>
  
</div>
<div *ngIf="fileTypes!=null && fileTypes!=undefined">
  <!--<p class="commonpara">
    Allowed file types: {{fileTypes}}
  </p>-->
  <h5 class="mr-auto margin-bottom-0">
    <i container="body" class="userpermissiontooltip margin-right-5" aria-hidden="true" placement="right">
      <img src="/assets/img/Frame.svg" class="info-icon-blue-position">
    </i>
    <span>Allowed file types: {{fileTypes}}</span>
  </h5>
</div>
